import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

export interface Banner {
  id: string;
  titulo: string;
  descricao?: string;
  imagemUrl: string;
  linkDestino?: string;
  posicao: 'home-hero' | 'home-middle' | 'sidebar' | 'footer';
  ordem: number;
  ativo: boolean;
  dataInicio?: string;
  dataFim?: string;
  criadoEm: string;
  atualizadoEm: string;
}

@Injectable({ providedIn: 'root' })
export class BannerService {
  constructor(private api: ApiService) {}

  list(filters?: any): Observable<Banner[]> {
    return this.api.get<Banner[]>('/admin/banners', filters || {});
  }

  get(id: string): Observable<Banner> {
    return this.api.get<Banner>(`/admin/banners/${id}`);
  }

  create(payload: Partial<Banner>): Observable<Banner> {
    return this.api.post<Banner>('/admin/banners', payload);
  }

  update(id: string, payload: Partial<Banner>): Observable<Banner> {
    return this.api.put<Banner>(`/admin/banners/${id}`, payload);
  }

  delete(id: string): Observable<any> {
    return this.api.delete(`/admin/banners/${id}`);
  }

  toggleActive(id: string): Observable<Banner> {
    return this.api.patch<Banner>(`/admin/banners/${id}/toggle-active`, {});
  }

  reorder(bannerIds: string[]): Observable<any> {
    return this.api.post('/admin/banners/reorder', { bannerIds });
  }
}
